<template>
  <header class="e-header">
    <div class="e-brand">
      <Logo :aria-label="$t('aria.logo')" />
      <component :is="logo" class="e-brand-secondary" />
    </div>
    <nav class="e-header__nav">
      <MetaNav />
    </nav>
    <div class="e-header__buttons">
      <template v-if="userInfo">
        <router-link
          :to="{
            name: 'dialogs'
          }"
          class="e-btn e-btn--secondary e-btn--thin e-header__button"
        >
          <IconEnvelope role="presentation" />
          <span class="e-mobile-hidden e-tablet-hidden">
            {{ $t('chat.emailSupport') }}
          </span>
        </router-link>

        <template>
          <router-link
            :to="{
              name: chatIsOpen ? 'liveChat' : 'chatLanding'
            }"
            :class="[
              { 'needs-chat-interaction': newChatMessage },
              'e-btn',
              'e-btn--thin',
              'e-btn--secondary',
              'e-header__button'
            ]"
          >
            <chat-icon
              :show-notification="false"
              :notification-message="$t('chat.newMessage')"
            />
            <span class="e-mobile-hidden e-tablet-hidden">
              {{ $t('chat.navigation') }}
            </span>
          </router-link>
        </template>
      </template>
      <el-button
        name="logoutbutton"
        class="e-btn--tertiary e-header__button e-btn--thin e-mobile-hidden logoutbutton"
        @click="logoutAndCatchFire"
      >
        <IconExclamation role="presentation" />
        <span class="e-mobile-hidden e-tablet-hidden">
          {{ $t('system.panic') }}
        </span>
      </el-button>
    </div>

    <button
      v-if="!dialogOpen && !chatDialogOpen && !messageEditorOpen"
      type="button"
      name="offcanvas_toggle"
      class="e-offcanvas__toggle"
      @click="toggleOffcanvas"
    >
    <div class="e-offcanvas__toggle-container">
      <span />
      <span />
      <span />
    </div>
    </button>
    <router-link
      v-if="
        !!chatDialogOpen &&
          ($route.name === 'chatDialogs' || $route.name === 'chatDialog')
      "
      :to="{ name: 'chatDialogs' }"
      class="e-header__toggle"
    >
      <IconChevronLeft />
    </router-link>
    <router-link
      v-if="
        !(!dialogOpen && !messageEditorOpen) &&
          ($route.name === 'dialogs' ||
            $route.name === 'dialog' ||
            $route.name === 'newDialog')
      "
      :to="{ name: 'dialogs' }"
      class="e-header__toggle"
    >
      <IconChevronLeft />
    </router-link>
    <router-link
      v-if="
        !(!dialogOpen && !messageEditorOpen) && $route.name === 'sentDialog'
      "
      :to="{ name: 'sent' }"
      class="e-header__toggle"
    >
      <IconChevronLeft />
    </router-link>
  </header>
</template>

<script>
import VueCookie from 'vue-cookie'
import { mapGetters, mapActions } from 'vuex'
import { userActions } from 'mixins'

import Logo from 'atoms/Logo/Logo'
import Logo1000grad from 'atoms/Logo/Logo1000grad'
import MetaNav from 'atoms/Metanav/Metanav'
import ChatIcon from 'atoms/ChatIcon/ChatIcon'

// Icons
import IconExclamation from 'assets/icons/basic-exclamation.svg'
import IconChevronLeft from 'assets/icons/chevron-left.svg'
import IconEnvelope from 'assets/icons/envelope.svg'

// Logos

export default {
  name: 'TheHeader',
  components: {
    IconExclamation,
    IconEnvelope,
    IconChevronLeft,
    MetaNav,
    Logo,
    Logo1000grad,
    ChatIcon
  },
  mixins: [userActions],

  computed: {
    ...mapGetters([
      'offcanvasOpen',
      'chatDialogOpen',
      'dialogOpen',
      'messageEditorOpen',
      'userInfo',
      'theme',
      'chatIsOpen',
      'newChatMessage'
    ]),
    logo() {
      if (['1000grad'].includes(this.theme)) {
        return 'Logo' + this.theme
      }
      return null
    }
  },
  methods: {
    ...mapActions(['setOffcanvas', 'logClosed']),
    toggleOffcanvas() {
      this.setOffcanvas(!this.offcanvasOpen)
    },
    logoutAndCatchFire() {
      this.logClosed()
      this.__user__logout(false)
      location.href = 'https://www.startpage.com'
    },
    isThemePausentasteActive() {
      return VueCookie.get('theme') && VueCookie.get('theme') === 'pausentaste'
    },
    isTheme1000GradActive() {
      return VueCookie.get('theme') && VueCookie.get('theme') === '1000grad'
    }
  }
}
</script>

<style lang="scss">
@import '_assets/header';
</style>
